import classNames from 'classnames';
import { ForwardedRef } from 'react';

import LoadingIcon from '../icons/LoadingIcon';
import PauseIcon from '../icons/PauseIcon';
import PlayIcon from '../icons/PlayIcon';
import BasicButton, { BasicButtonElement, BasicButtonProps } from './BasicButton';

import styles from '../../styles/buttons/control-button.module.css';

export interface PlayButtonProps extends BasicButtonProps {
    playing?: boolean;
    loading?: boolean;
    iconClassName?: string;
}

function PlayButton({
    playing = false,
    loading = false,
    className = null,
    iconClassName,
    children = null,
    ref: buttonRef = null,
    ...props
}: PlayButtonProps & { ref?: ForwardedRef<BasicButtonElement> | null }) {
    return (
        <BasicButton
            ref={buttonRef}
            className={classNames([styles.container, className])}
            {...props}
        >
            {loading ? (
                <LoadingIcon className={styles.loadingIcon} />
            ) : playing ? (
                <PauseIcon className={classNames([styles.icon, iconClassName])} />
            ) : (
                <PlayIcon className={classNames([styles.icon, iconClassName])} />
            )}
            {children}
        </BasicButton>
    );
}

export default PlayButton;
